import React from 'react';
import Contact from '../components/Contact';

export default function Kontakt() {
  return (
    <div>
      <h1>Kontakt</h1>
      <Contact />
    </div>
  );
}
